var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.serveStatus === 'live')?[_c('beach-club-live',{attrs:{"url_id":_vm.geturlDomain,"outlet_id":''}})]:[_c('beach-club',{attrs:{"url_id":_vm.geturlDomain,"outlet_id":''}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }